// MyDataGrid.jsx
import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";

const DataGridMarifer = ({
  rows = [],
  columns = [],
  defaultPageSize = 15,
  rowsPerPageOptions = [5, 10, 15, 20, 30, 50, 100],
  initialState,
}) => {
  const [pageSize, setPageSize] = useState(defaultPageSize);

  return (
    // <div className="mt-8 h-[600px] w-full dark:text-white">
    <DataGrid
      className="mt-8 h-max w-full dark:text-white"
      rows={rows}
      columns={columns}
      pageSize={pageSize}
      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
      rowsPerPageOptions={rowsPerPageOptions}
      checkboxSelection
      disableSelectionOnClick
      pagination
      initialState={initialState}
    />
    // </div>
  );
};

export default DataGridMarifer;
